import * as React from 'react';
import {Breadcrumb, Grid, Input} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
  ColumnSelectableComponentProps,
  ColumnSortableComponentProps,
  FilterObjectComponentProps,
  InfinityScrollComponentProps,
  ViewSettingsComponentProps,
  withColumnSelection,
  withColumnSort,
  withFilterObject,
  withInfinityScrollHandlers,
  withPrintAndExport,
  withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import LogisticsServiceSingleton from "../../services/LogisticsService";
import Moment from 'react-moment';
import moment from 'moment';
import InventoryAccountModal from './InventoryAccountModal';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'kontonummer',
        labelTranslationKey: 'Inventory.Account',
        required: true
    }, {
        fieldName: 'kurzname',
        labelTranslationKey: 'Inventory.ShortName',
        required: true
    },
    {
        fieldName: 'LT',
        labelTranslationKey: 'Inventory.LTNumber',
        required: true,
    },
    {
        fieldName: 'kurztext',
        labelTranslationKey: 'Inventory.ShortText',
        required: true,
        cellRender: (v,row) =>  <NavLink
            to={`/logistics/inventory/${row.kontonummer}/${row.LT}`}>{v}</NavLink>
    },
    {
        fieldName: 'bestand1',
        labelTranslationKey: 'Inventory.Stock1',
        required: false,
      cellAlign: 'right'
    },
    {
        fieldName: 'bestand2',
        labelTranslationKey: 'Inventory.Stock2',
        required: false,
      cellAlign: 'right'
    },
    {
        fieldName: 'bestand3',
        labelTranslationKey: 'Inventory.Stock3',
        required: false,
      cellAlign: 'right'
    },
    {
        fieldName: 'bestand4',
        labelTranslationKey: 'Inventory.Stock4',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'maxDatum',
        labelTranslationKey: 'Inventory.Date',
        required: false,
        cellRender: (v,r) => <Moment format={t("Common.DateFormat")}>{r.maxDatum + 'T' + r.maxZeit}</Moment>,
        printExportRender: (v,r) => moment(r.maxDatum + 'T' + r.maxZeit).format(t("Common.DateFormat"))
    },
    {
        fieldName: 'maxZeit',
        labelTranslationKey: 'Inventory.Time',
        required: false,
        cellRender: (v,r) => <Moment format={t("Common.TimeFormat")}>{r.maxDatum + 'T' + r.maxZeit}</Moment>, // to support winter/summer time include date
        printExportRender: (v,r) => moment(r.maxDatum + 'T' + r.maxZeit).format(t("Common.TimeFormat"))
    }

];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

const Inventory = (props: RouteComponentProps<any> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {

    if(props.loadingInitial) {
    return <LoadingContainer showLogo={false}/>;
  }
  return (
      <>
          <AnalyticsTracking page="logistics" />
          <div className={"sticky-header"}>
              <div className={"ui container"}>

                  <h3><Breadcrumb icon="right angle" sections={[
                      {
                          key: '1',
                          as: NavLink,
                          to:  "/inventory/",
                          content: `${t ("Route.Inventory")}`,
                      }
                  ]} /></h3>

                  <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
                  <Grid columns={4} className={"HeadingGrid"} stackable={true}
                        style={{marginBottom: '1em'}}>
                    <Grid.Column width={5}>
                      <InventoryAccountModal chooseFunc={(newFilter: any) => props.handleFilterChange('filter', newFilter)}/>
                    </Grid.Column>
                      <Grid.Column width={5}>
                          <Input fluid icon={'search'} placeholder={t("Forms.Placeholder.Search")} disabled={props.loading}
                                 value={props.filterObject.filter}
                                 onChange={(_,data) => props.handleFilterChange('filter', data.value)}/>
                      </Grid.Column>
                      <Grid.Column width={5}>
                          <ColumnSelectionButton
                              fluid
                              availableColumns={COLUMNS}
                              selectedColumns={props.selectedColumns}
                              onSave={props.updateSelectedColumns}/>
                      </Grid.Column>
                      <Grid.Column width={1}>
                          <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                              <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                              </div>
                          </div>
                      </Grid.Column>
                  </Grid>
              </div>
          </div>


          <div className={"ui container responsivewrapper"}>
              <DataTable
                  columns={COLUMNS}
                  data={props.data}
                  page={props.page}
                  totalPages={props.totalPages}
                  sortDirection={props.sortDirection}
                  sortColumn={props.sortColumn}
                  selectedColumns={props.selectedColumns}
                  getScrollParent={getScrollParent}
                  loadMore={props.loadMore}
                  handleSortChange={props.handleSortChange}
                  loading={props.loading}
                  filter={props.filterObject}
              />
              <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
                  <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                  </div>
              </div>
              <div style={{height: '2em'}}/>
          </div>
      </>
  )
};

const dataService = {
  loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }): Promise<any> {
    return  LogisticsServiceSingleton.getAllInventoryData(sortColumn, sortOrder, page, 50, filter.filter ? filter.filter : "");
  }
};

const InventoryWrapped = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(Inventory)))))));

export default () => (
    <InventoryWrapped
        viewName="inventory"
        dataService={dataService}
        defaultSortDirection="ASC"
        defaultSortColumn="kontonummer"
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilter={{
        }}
        printColumns={COLUMNS}
        printPath={[`${t ("Route.Inventory")}`]}
    />
);